import { useState } from "react";
import { toast } from "sonner";
import { api, errMsg, FIELD } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Field } from "@/components/common/Field";
import { Input } from "@/components/ui/input";

const ForgotPassword = ({ onDone }) => {
  const [step, setStep] = useState(0);
  const [f, setF] = useState({ email: "", code: "", new_password: "" });
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const send = async (e) => {
    e.preventDefault();
    setBusy(true);
    try { await api.post("/auth/forgot-password", { email: f.email }); setStep(1); toast.success("If that email is an admin account, a 6-digit code is on its way."); }
    catch (err) { toast.error(errMsg(err)); } finally { setBusy(false); }
  };
  const reset = async (e) => {
    e.preventDefault();
    setBusy(true);
    try { await api.post("/auth/reset-password", f); toast.success("Password updated. Please sign in."); onDone(); }
    catch (err) { toast.error(errMsg(err)); } finally { setBusy(false); }
  };

  return step === 0 ? (
    <form onSubmit={send} className="space-y-4" data-testid="forgot-password-form">
      <Field label="Admin Email"><Input className={FIELD} type="email" required value={f.email} onChange={set("email")} data-testid="forgot-email-input" /></Field>
      <button className="btn-gold w-full" disabled={busy} data-testid="forgot-send-code-button">{busy ? "Sending…" : "Email Me a Code"}</button>
      <button type="button" onClick={onDone} className="text-xs text-white/50 hover:text-white w-full py-2" data-testid="forgot-back-button">Back to sign in</button>
    </form>
  ) : (
    <form onSubmit={reset} className="space-y-4" data-testid="reset-password-form">
      <Field label="6-Digit Code"><Input className={FIELD} inputMode="numeric" maxLength={6} required value={f.code} onChange={set("code")} data-testid="reset-code-input" /></Field>
      <Field label="New Password (10+ characters)"><Input className={FIELD} type="password" minLength={10} required value={f.new_password} onChange={set("new_password")} data-testid="reset-new-password-input" /></Field>
      <button className="btn-gold w-full" disabled={busy} data-testid="reset-submit-button">{busy ? "Saving…" : "Set New Password"}</button>
    </form>
  );
};

export const AdminLoginForm = () => {
  const { signInWithPassword } = useAuth();
  const [forgot, setForgot] = useState(false);
  const [f, setF] = useState({ email: "", password: "" });
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try { await signInWithPassword(f.email, f.password); } catch (err) { toast.error(errMsg(err)); } finally { setBusy(false); }
  };

  if (forgot) return <ForgotPassword onDone={() => setForgot(false)} />;
  return (
    <form onSubmit={submit} className="space-y-4" data-testid="admin-password-login-form">
      <Field label="Email"><Input className={FIELD} type="email" autoComplete="username" required value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} data-testid="admin-login-email-input" /></Field>
      <Field label="Password"><Input className={FIELD} type="password" autoComplete="current-password" required value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} data-testid="admin-login-password-input" /></Field>
      <button className="btn-gold w-full" disabled={busy} data-testid="admin-login-submit-button">{busy ? "Signing in…" : "Sign In"}</button>
      <button type="button" onClick={() => setForgot(true)} className="text-xs text-[#D4AF37] hover:underline w-full py-2" data-testid="admin-forgot-password-link">Forgot password?</button>
    </form>
  );
};
